<script>
    import { getContext } from 'svelte';
    import { Policy } from "@Store";
    import Question from "@components/Question.svelte";
    import 'animate.css';
    import { computeApplicantValid } from '@routes/validators/validator';

    const CONTEXT = getContext('CONTEXT');

    $: questions = $Policy.questions ? $Policy.questions : [];
    $: valid = $Policy.valid;

    // APPLICANT QUESTIONS SECTION

    // Create a lookup map in one pass - much more efficient!
    $: questionMap = questions.reduce((map, question) => {
        map[question.question] = question;
        return map;
    }, {});

    // Now you can access any question efficiently
    $: ({
        'Desired Effective Date': desired_effective_date_question,
        'Name of Naturopathic Doctor': named_insured_question,
        'Name of Clinic': operating_name_question,
        'Applicant Mailing Address': mailing_address_question,
        'Contact Name/Title': contact_name_title_question,
        'Phone Number': phone_number_question,
        'Email': email_question,
        'Website': website_question,
        'Year Established': year_established_question,
        'Are you a CAND member?': cand_member_question,
        'Member since:': member_since_question
    } = questionMap);

    // Create named values lookup map - ONE iteration instead of 9!
    $: namedValuesMap = ($Policy.saved_named_values || []).reduce((map, nv) => {
        map[nv.name] = nv.value?.trim() || '';
        return map;
    }, {});

    // Helper function to check if a named value exists and is not empty
    const isAnswered = (map, key) => !!map[key];
    $: getAnswerText = (q) => (q && $Policy.answers?.[q.id]?.text_answer || '').trim();
    $: isAnsweredById = (q) => !!getAnswerText(q);

    // Now efficiently check all values
    $: is_cand_member = namedValuesMap['cand_member']?.toLowerCase().includes('yes');

    // ONCE ALL THE ABOVE ARE ANSWERED, SET VALID TO TRUE
    $: applicant_valid = computeApplicantValid($Policy);

    // Update CONTEXT when validation changes
    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            applicant: applicant_valid
        }));
    }

    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }

    function handleEffectiveDateUpdate(e) {
        CONTEXT.handleEffectiveDateUpdate(e);
    }


</script>

<div class="page-container">
    <div class="questions-wrapper">
        <!-- APPLICANT QUESTIONS -->
        {#if desired_effective_date_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={desired_effective_date_question} policy={$Policy} on:updatedEffectiveDate={handleEffectiveDateUpdate} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if named_insured_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={named_insured_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if operating_name_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={operating_name_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if mailing_address_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={mailing_address_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if contact_name_title_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={contact_name_title_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if phone_number_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={phone_number_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if email_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={email_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if website_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={website_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if year_established_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={year_established_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if cand_member_question}
            <div class="animate__animated animate__fadeInUp">
                <Question question={cand_member_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
        {#if member_since_question && is_cand_member}
            <div class="animate__animated animate__fadeInUp">
                <Question question={member_since_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
            </div>
        {/if}
    </div>
</div>

<style>
    .page-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .questions-wrapper {
        width: 100%;
        max-width: 500px;
        margin-bottom: 2rem;
    }

</style>